export default "__VITE_ASSET__Dps6Ya6P__"